import * as React from "react";
const SvgAppLogo = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 180, height: 40, viewBox: "0 0 180 40", ...props }, /* @__PURE__ */ React.createElement("image", { href: "/appLogo.png", x: 0, y: 0, width: 180, height: 40, preserveAspectRatio: "xMidYMid meet" }));
export default SvgAppLogo;
